var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38.632 21.253H9.382c-.68 0-1.23-.5-1.23-1.116s.55-1.117 1.23-1.117h29.25c.68 0 1.23.5 1.23 1.117 0 .616-.55 1.116-1.23 1.116m-7.327 5.813c-.68 0-1.238-.5-1.238-1.117 0-.616.544-1.116 1.223-1.116h.015c.68 0 1.23.5 1.23 1.116s-.55 1.117-1.23 1.117m-7.282 0c-.68 0-1.238-.5-1.238-1.117 0-.616.543-1.116 1.223-1.116h.015c.679 0 1.23.5 1.23 1.116s-.551 1.117-1.23 1.117m-7.298 0c-.68 0-1.24-.5-1.24-1.117 0-.616.546-1.116 1.225-1.116h.015c.68 0 1.23.5 1.23 1.116s-.55 1.117-1.23 1.117m14.58 5.784c-.68 0-1.238-.5-1.238-1.117 0-.616.544-1.116 1.223-1.116h.015c.68 0 1.23.5 1.23 1.116s-.55 1.117-1.23 1.117m-7.282 0c-.68 0-1.238-.5-1.238-1.117 0-.616.543-1.116 1.223-1.116h.015c.679 0 1.23.5 1.23 1.116s-.551 1.117-1.23 1.117m-7.298 0c-.68 0-1.24-.5-1.24-1.117 0-.616.546-1.116 1.225-1.116h.015c.68 0 1.23.5 1.23 1.116s-.55 1.117-1.23 1.117m13.911-17.72c-.68 0-1.231-.5-1.231-1.116V9.117c0-.616.551-1.116 1.23-1.116.68 0 1.231.5 1.231 1.116v4.899c0 .616-.551 1.116-1.23 1.116Zm-13.256 0c-.68 0-1.232-.5-1.232-1.116V9.117C16.148 8.5 16.7 8 17.38 8s1.231.5 1.231 1.116v4.899c0 .616-.551 1.116-1.23 1.116Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "icon-calendar_svg__a",
  width: 32,
  height: 30,
  x: 8,
  y: 10,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8 10.35h32V40H8z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon-calendar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.06 12.583c-4.256 0-6.6 2.059-6.6 5.796v13.468c0 3.82 2.344 5.921 6.6 5.921h13.88c4.254 0 6.598-2.063 6.598-5.808V18.38c.006-1.839-.538-3.268-1.62-4.25-1.112-1.012-2.827-1.547-4.964-1.547zM30.94 40H17.06C11.472 40 8 36.876 8 31.847V18.38c0-4.953 3.472-8.028 9.06-8.028h13.895c2.804 0 5.123.762 6.706 2.2 1.538 1.401 2.347 3.415 2.339 5.83v13.58C40 36.92 36.528 40 30.94 40",
  clipRule: "evenodd"
}))));
export default SvgIconCalendar;